import { Injectable, ComponentRef, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { TourCreditDropdownComponent } from '../components/tours/tour-credit/dropdown/tour-credit-dropdown.component';

@Injectable({
  providedIn: 'root',
})
export class TourCreditDropdownService {
  popupComponentRef: ComponentRef<TourCreditDropdownComponent>;
  recalcRef: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  public open(recalcRef: ViewContainerRef): ComponentRef<TourCreditDropdownComponent> {
    this.recalcRef = recalcRef;
    this.appendDialogComponent();

    return this.popupComponentRef;
  }

  public close() {
    this.removeDialogComponent();
  }

  private appendDialogComponent() {
    if (this.popupComponentRef) {
      this.removeDialogComponent();
    }

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(TourCreditDropdownComponent);
    const componentRef = this.recalcRef.createComponent(componentFactory);

    this.popupComponentRef = componentRef;
  }

  private removeDialogComponent() {
    this.popupComponentRef.destroy();
  }
}
